import axios from "axios";
import { notification } from "../utils/Notifications.tsx";
import { deepParseJson } from "../utils/index.ts";
import io from 'socket.io-client';

const baseURL = process.env.REACT_APP_API_URL;
//const baseURL = "https://api.chilith.com.mx";

const httpClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use(
  async function (config) {
    const rawPersistData = localStorage.getItem("persist:root");
    const persistData = deepParseJson(rawPersistData);
    const token = persistData?.auth?.token;

    config.headers = {
      "Content-Type": "application/json",
    };

    if (token) config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        notification("Error", "No autorizado", "danger");
        const event = new CustomEvent("unauthorized");
        window.dispatchEvent(event);
      }
      return Promise.reject(error.response.data);
    } else {
      return Promise.reject({
        status: 500,
        message: "Error de conexión con el servidor.",
      });
    }
  }
);

export default httpClient;

const httpFormDataClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

httpFormDataClient.interceptors.request.use(
  function (config) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };

    const rawPersistData = localStorage.getItem("persist:root");
    const persistData = deepParseJson(rawPersistData);
    const token = persistData?.auth?.token;

    if (token) config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export { httpFormDataClient };
